

import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

const ACCESS_KEY = "sqi.auth.access";
const REFRESH_KEY = "sqi.auth.refresh";

const isNative = Capacitor.isNativePlatform();

export const tokenStore = {
  isNative,

  async getAccess(): Promise<string | null> {
    if (!isNative) return null;
    const { value } = await Preferences.get({ key: ACCESS_KEY });
    return value ?? null;
  },

  async getRefresh(): Promise<string | null> {
    if (!isNative) return null;
    const { value } = await Preferences.get({ key: REFRESH_KEY });
    return value ?? null;
  },

  async setAccess(token: string): Promise<void> {
    if (!isNative) return;
    await Preferences.set({ key: ACCESS_KEY, value: token });
  },

  async setRefresh(token: string): Promise<void> {
    if (!isNative) return;
    await Preferences.set({ key: REFRESH_KEY, value: token });
  },

  async setBoth(access: string, refresh: string): Promise<void> {
    if (!isNative) return;
    await Preferences.set({ key: ACCESS_KEY, value: access });
    await Preferences.set({ key: REFRESH_KEY, value: refresh });
  },

  async clear(): Promise<void> {
    if (!isNative) return;
    await Preferences.remove({ key: ACCESS_KEY });
    await Preferences.remove({ key: REFRESH_KEY });
  },
};
